import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "dashboard-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 2.25C3.0335 2.25 2.25 3.0335 2.25 4V9C2.25 9.9665 3.0335 10.75 4 10.75H9C9.9665 10.75 10.75 9.9665 10.75 9V4C10.75 3.0335 9.9665 2.25 9 2.25H4ZM3.75 4C3.75 3.86193 3.86193 3.75 4 3.75H9C9.13807 3.75 9.25 3.86193 9.25 4V9C9.25 9.13807 9.13807 9.25 9 9.25H4C3.86193 9.25 3.75 9.13807 3.75 9V4Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15 2.25C14.0335 2.25 13.25 3.0335 13.25 4V9C13.25 9.9665 14.0335 10.75 15 10.75H20C20.9665 10.75 21.75 9.9665 21.75 9V4C21.75 3.0335 20.9665 2.25 20 2.25H15ZM14.75 4C14.75 3.86193 14.8619 3.75 15 3.75H20C20.1381 3.75 20.25 3.86193 20.25 4V9C20.25 9.13807 20.1381 9.25 20 9.25H15C14.8619 9.25 14.75 9.13807 14.75 9V4Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.25 15C2.25 14.0335 3.0335 13.25 4 13.25H9C9.9665 13.25 10.75 14.0335 10.75 15V20C10.75 20.9665 9.9665 21.75 9 21.75H4C3.0335 21.75 2.25 20.9665 2.25 20V15ZM4 14.75C3.86193 14.75 3.75 14.8619 3.75 15V20C3.75 20.1381 3.86193 20.25 4 20.25H9C9.13807 20.25 9.25 20.1381 9.25 20V15C9.25 14.8619 9.13807 14.75 9 14.75H4Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15 13.25C14.0335 13.25 13.25 14.0335 13.25 15V20C13.25 20.9665 14.0335 21.75 15 21.75H20C20.9665 21.75 21.75 20.9665 21.75 20V15C21.75 14.0335 20.9665 13.25 20 13.25H15ZM14.75 15C14.75 14.8619 14.8619 14.75 15 14.75H20C20.1381 14.75 20.25 14.8619 20.25 15V20C20.25 20.1381 20.1381 20.25 20 20.25H15C14.8619 20.25 14.75 20.1381 14.75 20V15Z"
    }, null, -1)
  ])))
}
export default { render: render }